import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { toast } from "sonner";
import { Trash2, Mail } from "lucide-react";

export default function ContactsManager() {
  const [items, setItems] = useState([]);

  const load = async () => {
    const { data } = await api.get("/admin/contact-submissions");
    setItems(data);
  };
  useEffect(() => { load(); }, []);

  const markRead = async (id) => {
    await api.put(`/admin/contact-submissions/${id}/read`);
    load();
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Anfrage löschen?")) return;
    await api.delete(`/admin/contact-submissions/${id}`);
    toast.success("Gelöscht");
    load();
  };

  return (
    <div data-testid="contacts-manager">
      <h3 className="font-display text-2xl text-stone-900 mb-6">Kontaktanfragen ({items.length})</h3>
      {items.length === 0 ? (
        <p className="text-stone-600 italic" data-testid="contacts-empty">Noch keine Anfragen erhalten.</p>
      ) : (
        <div className="space-y-4">
          {items.map((c) => (
            <div key={c.id} data-testid={`contact-row-${c.id}`} className="bg-white border border-sand-300 rounded-sm p-6">
              <div className="flex flex-wrap items-start justify-between gap-3 mb-3">
                <div className="min-w-0">
                  <div className="flex items-center gap-3 flex-wrap">
                    <p className="font-medium text-stone-900">{c.name}</p>
                    {!c.is_read && <Badge className="bg-clay text-sand-100 hover:bg-clay-hover text-[10px] uppercase tracking-wider">Neu</Badge>}
                  </div>
                  <p className="text-sm text-stone-600 mt-1">
                    <a href={`mailto:${c.email}`} className="hover:text-clay">{c.email}</a>
                    {c.phone && <span> · {c.phone}</span>}
                  </p>
                  <p className="text-xs text-stone-600 mt-1">{new Date(c.created_at).toLocaleString("de-DE")}</p>
                </div>
                <div className="flex gap-2">
                  {!c.is_read && (
                    <Button size="sm" variant="outline" onClick={() => markRead(c.id)} data-testid={`contact-read-${c.id}`} className="border-sand-300">
                      <Mail className="w-4 h-4 mr-1" /> Als gelesen
                    </Button>
                  )}
                  <Button size="sm" variant="ghost" onClick={() => handleDelete(c.id)} data-testid={`contact-delete-${c.id}`} className="text-stone-700 hover:text-clay hover:bg-sand-200">
                    <Trash2 className="w-4 h-4" />
                  </Button>
                </div>
              </div>
              {c.subject && <p className="text-stone-900 font-medium mb-2">Betreff: {c.subject}</p>}
              <p className="text-stone-700 whitespace-pre-wrap">{c.message}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
